import { render, staticRenderFns } from "./bo-announcement-bar.vue?vue&type=template&id=0651ab60"
import script from "./bo-announcement-bar.vue?vue&type=script&lang=js"
export * from "./bo-announcement-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports